import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
const store = new Vuex.Store({
      state: {
            isUserLogin: false,
            userInfo: null,
      },
      mutations: {
            async changeData(state, data) {
                  state[data.key] = data.val;
            },
      },
      actions: {
            async changeData(context, payload) {
                  context.commit('changeData', payload)
            },
      },
      getters: {
            isUserLogin(state){
                  return  state.isUserLogin
            }, 
            userInfo(state){
                  return  state.userInfo
            } 
      }
})

export default store